import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { API } from 'network/api';

export type FertilizerLog = {
  createdBy: string;
  lastModifiedBy: string;
  lastModifiedDate: string;
  id: string;
  name: string;
  internalCode: string;
  fertilizerType: string;
  applicationType: string;
  brand: string;
  nitrogenComposition: number;
  phosphorusComposition: number;
  potassiumComposition: number;
  sulfurComposition: number;
  dosage: number;
  dosageUom: string;
  applicationDate: string;
  fertilizerId: number;
  taskLogsId: string;
  reportedDate: string;
};

const useFertilizerQuery = (id?: string) => {
  const query = useQuery<AxiosResponse<FertilizerLog[]>>({
    queryKey: ['fertilizer-logs', id],
    queryFn: () =>
      API.get('/fertilizer-logs', {
        params: { taskLogsId: id },
      }),
    enabled: !!id,
  });

  return query;
};

export default useFertilizerQuery;
